export default __webpack_public_path__ + "static/media/video_montages.0a929c5f.jpg";